<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import Dropdown from "./Dropdown.svelte";
    import type { ItemType } from "./types";

    export let component: string[];
    export let dayItems: ItemType[];
    export let monthItems: ItemType[];
    export let yearItems: ItemType[];
    export let value: {
        day: number | null;
        month: number | null;
        year: number | null;
    } = { day: null, month: null, year: null };

    const dispatch = createEventDispatcher();

    const handleChange = (
        key: "day" | "month" | "year",
        newValue: number | null
    ) => {
        const updatedValue = { ...value, [key]: newValue };
        dispatch("change", { value: updatedValue });
    };
</script>

<div class="gw-select-date">
    {#if component.includes("day")}
        <Dropdown
            placeholderText="Select day"
            items={dayItems}
            value={value.day === null ? "" : value.day}
            on:change={(e) => handleChange("day", +e.detail.value)}
            inputAttributes={{ name: "select-day" }}
        />
    {/if}

    {#if component.includes("month")}
        <Dropdown
            placeholderText="Select month"
            items={monthItems}
            value={value.month === null ? "" : value.month}
            on:change={(e) => handleChange("month", +e.detail.value)}
            inputAttributes={{ name: "select-month" }}
        />
    {/if}

    {#if component.includes("year")}
        <Dropdown
            placeholderText="Select year"
            items={yearItems}
            value={value.year === null ? "" : value.year}
            on:change={(e) => handleChange("year", +e.detail.value)}
            inputAttributes={{ name: "select-year" }}
        />
    {/if}
</div>

<style lang="postcss">
    .gw-select-date {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
</style>
